import { render, staticRenderFns } from "./GroupPropertiesEdit.vue?vue&type=template&id=602810ca&scoped=true&"
import script from "./GroupPropertiesEdit.vue?vue&type=script&lang=js&"
export * from "./GroupPropertiesEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupPropertiesEdit.vue?vue&type=style&index=0&id=602810ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602810ca",
  null
  
)

export default component.exports